import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { setRegisterData, nextRegisterStep } from 'modules/auth/actions';
import { dispatch } from 'store';
import { Input, Button } from 'views/components';
import { RootState } from 'types';
import { routes } from 'routes';

import { PrevStep } from '../../components/PrevStep';

import { t } from 'utils';
import styles from './SecondStep.module.css';
import texts from '../../../texts';

export const SecondStep: FC = () => {
  const { registerData } = useSelector((state: RootState) => state.auth);
  const [validEmail, setValidEmail] = useState(true);

  const handleInputChange = (event: any) => {
    const {
      name,
      value,
      validity: { valid },
    } = event.target;
    if (name === 'email') {
      dispatch(setRegisterData(name, value));
      if (valid) {
        setValidEmail(true);
      } else {
        setValidEmail(false);
      }
    } else if (valid) {
      dispatch(setRegisterData(name, value));
    }
  };

  const { fullName, email, password, passwordConfirm, phoneNumber } = registerData;

  const disabled =
    !fullName || !email || !password || password.length < 6 || !passwordConfirm || !validEmail;
  const unconfirmPasword = password !== passwordConfirm;

  return (
    <div className={styles.container}>
      <PrevStep step={2} />
      <h1 style={{ fontSize: 40, fontWeight: 'bold', lineHeight: '50px' }}>
        {t(texts.secondStepTitle)}
      </h1>
      <p>{t(texts.secondStepDesc)}</p>
      <div className={styles.items}>
        <div className={styles.item}>
          <Input
            name="fullName"
            value={fullName}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.secondStepInputLabel1)}
            pattern="[a-zA-Z\s]+"
            maxLength={128}
          />
        </div>
        <div className={styles.item}>
          <Input
            name="phoneNumber"
            value={phoneNumber}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.secondStepInputLabel2)}
            pattern="[0-9]*"
            maxLength={16}
          />
        </div>
      </div>
      <Input
        name="email"
        value={email}
        onChange={(e: any) => handleInputChange(e)}
        label={t(texts.secondStepInputLabel3)}
        type="email"
        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
        maxLength={128}
      />
      <Input
        name="password"
        value={password}
        onChange={(e: any) => handleInputChange(e)}
        label={t(texts.secondStepInputLabel4)}
        type="password"
        maxLength={64}
      />
      <Input
        name="passwordConfirm"
        value={passwordConfirm}
        onChange={(e: any) => handleInputChange(e)}
        label={t(texts.secondStepInputLabel5)}
        type="password"
        maxLength={64}
      />
      {unconfirmPasword && <p style={{ fontSize: '12px', color: 'red' }}>Password mismatch</p>}
      <div style={{ marginTop: '40px', width: '150px' }}>
        <Button
          disabled={disabled || unconfirmPasword}
          title={t(texts.general.continue)}
          onClick={() => dispatch(nextRegisterStep())}
        />
      </div>{' '}
      <div style={{ marginBottom: '50px' }}>
        <Link className={styles.link} to={routes.signin}>
          {t(texts.secondStepAccountLink)}
        </Link>
      </div>
    </div>
  );
};
